import classNames from 'classnames';
import type { ComponentPropsWithoutRef, ElementType } from 'react';

import styles from './Label.module.css';

type Size = 'sm' | 'md' | 'lg';
type FontWeight = 'normal' | 'semibold';

type LabelProps<T extends ElementType = 'label'> = {
  as?: T;
  size?: Size;
  fontWeight?: FontWeight;
  disabled?: boolean;
  clickable?: boolean;
} & Omit<ComponentPropsWithoutRef<T>, 'size' | 'as'>;

export const Label = <T extends ElementType = 'label'>({
  children,
  as,
  size = 'md',
  fontWeight = 'semibold',
  disabled = false,
  className,
  onClick,
  ...rest
}: LabelProps<T>) => {
  const Component = as ?? 'label';

  return (
    <Component
      className={classNames(
        styles.label,
        styles[size],
        styles[fontWeight],
        onClick && styles.clickable,
        disabled && styles.disabled,
        className
      )}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Component>
  );
};
